// extracted by mini-css-extract-plugin
export default {"header":"MenuHamburguesa_header__bH-E5","lista":"MenuHamburguesa_lista__cF1Ow","nav_name":"MenuHamburguesa_nav_name__omy5z","nav_link":"MenuHamburguesa_nav_link__LEck8"};